import axios, { AxiosError } from 'axios';
import Cookies from 'js-cookie';
import env from './env';
import Swal from 'sweetalert2';

export const CONTENT_JSON = 'application/json';
export const CONTENT_FORMDATA = 'multipart/form-data';

export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';
export const PATCH = 'PATCH';

// Api inicial
export const obtenerHeadersApi = (token?: string) => {
  const tokenCookies = Cookies.get('t');
  return {
    'Content-Type': CONTENT_JSON,
    Authorization: `Bearer ${token ?? tokenCookies ?? ''}`,
  };
};

const api = axios.create({
  baseURL: `${env.API.URL}${env.API.MODULO}`,
  headers: obtenerHeadersApi(),
});

// Interceptores para añadir el token de forma dinámica
api.interceptors.request.use(
  (config) => {
    // Utilizo el token guardado en la store
    const tokenStore = Cookies.get('t');

    if (tokenStore) {
      config.headers.Authorization = `Bearer ${tokenStore}`;
    }
    return config;
  },
  async (error: AxiosError) => {
    if (error.response.status === 401 || error.response.status === 403) {
      await Swal.fire({
        title: 'Usted no posee permisos para realizar la petición.',
        icon: 'error',
        confirmButtonColor: 'var(--bGreen-600)',
        confirmButtonText: 'Continuar',
      });
      Cookies.remove('t');

      // Para el controlar la expiracion del token de sesion
      // Ver useRutasProtegidas.ts
    }

    return Promise.reject(error);
  }
);

export default api;
